<template>
  <v-app id="login">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6 lg5>
            <v-card class="pf-box-shadow-2 border-radius-10 pt-4 px-3 pb-3">
              <v-card-text class="pb-0">
                <!-- <div class="layout column align-center pb-4">
                  <img src="/static/login_logo.png" alt="Parent Finder">
                </div> -->
                <v-flex class="flex-center">
                  <h3 v-if="otpVerified" class="pf-login-head">New Password</h3>
                  <h3 v-else-if="otpSent" class="pf-login-head">Password Recovery Code</h3>
                  <h3 v-else class="pf-login-head">Password Recovery</h3>
                </v-flex>
                <v-layout class="pf-error-alert" v-if="longError">
                  <v-flex class="flex-row">
                    <v-icon size="17" class="red--text mr-2">warning</v-icon>
                    <span class="error-text">{{ longError }}</span>
                  </v-flex>
                </v-layout>
                <p v-if="otpVerified" class="mt-3 pf-text-dark font-weight-medium">Please enter your new password.</p>
                <v-flex v-else-if="otpSent">
                  <p class="mt-3 pf-text-dark font-weight-medium">We've sent you an email with password reset code. If the email doesn't show up soon, check your spam folder.</p>
                  <p class="mt-3 pf-text-dark font-weight-medium">Enter the 6 digit verification code</p>
                </v-flex>
                <p v-else class="mt-3 pf-text-dark font-weight-medium">Enter your username associated with your Parentfinder account. You can click on Forgot username if you don't know the username.</p>
                <v-form>
                  <template v-if="otpVerified">
                    <v-form ref="forgotPasswordForm">
                      <v-text-field 
                        name="password" ref="password"
                        :type="showPassword ? 'text' : 'password'"
                        :rules="passwordRules"
                        height="40"
                        browser-autocomplete="new-password"
                        autofocus
                        label="Enter your password" v-model.trim="password"
                        v-on:keyup.enter="submitPassword"
                      >
                        <template v-slot:append>
                          <span class="input-show-hide" icon @click="showPassword = !showPassword">
                            {{ showPassword ? 'Hide' : 'Show' }}
                          </span>
                        </template>
                      </v-text-field>
                      <v-text-field 
                        name="repeat-password" ref="repeat-password"
                        label="Confirm password" v-model.trim="repeatPassword"
                        height="40"
                        :type="showPassword2 ? 'text' : 'password'"
                        :rules="confirmPasswordRules"
                        v-on:keyup.enter="submitPassword"
                        browser-autocomplete="new-password-confirm"
                      >
                      <template v-slot:append>
                        <span class="input-show-hide" icon @click="showPassword2 = !showPassword2">
                          {{ showPassword2 ? 'Hide' : 'Show' }}
                        </span>
                      </template>
                      </v-text-field>
                      <v-layout class="pf-info-alert" style="width: 70%">
                        <v-flex class="flex-column">
                          <v-flex class="flex-row">
                            <span class="pf-text-dark font-weight-medium">Password must have,</span>
                          </v-flex>
                          <ul class="my-2">
                            <li>
                              8 characters minimum
                              <v-icon size="17" class="red--text mr-1" :class="{ 'green--text': password.length >= 8 }">{{ 8 > password.length ? 'cancel' : 'check_circle'}}</v-icon>
                            </li>
                            <li>
                              An uppercase letter
                              <v-icon size="17" class="red--text mr-1" :class="{ 'green--text': /[A-Z]/.test(password) }">{{ /[A-Z]/.test(password) ? 'check_circle' : 'cancel' }}</v-icon>
                            </li>
                            <li>
                              At least 1 numeric character
                              <v-icon size="17" class="red--text mr-1" :class="{ 'green--text': /\d/.test(password) }">{{ /\d/.test(password) ? 'check_circle' : 'cancel' }}</v-icon>
                            </li>
                          </ul>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </template>
                  <v-text-field 
                    v-else-if="!otpSent"
                    name="username" ref="username"
                    autofocus
                    label="Enter your username" type="text" v-model.trim="username"
                    height="40"
                    v-on:keyup.enter="submitUsername"
                  ></v-text-field>
                  <!-- <v-text-field 
                    v-else
                    name="otp" ref="otp"
                    append-icon="pin"
                    autofocus
                    type="text" v-model.trim="otp"
                    placeholder="* * * * * *"
                    class="otp-field"
                    height="40"
                    counter="6"
                    v-on:keyup.enter="submitOTP"
                  ></v-text-field> -->
                  <v-flex v-else class="flex-center my-2">
                    <div class="otp-container">
                      <input type="text" autofocus maxlength="1" class="otp-input" min="0" max="9" pattern="[0-9]" id="digit1" @input="focusNext($event)" />
                      <input type="text" maxlength="1" class="otp-input" min="0" max="9" pattern="[0-9]" id="digit2" @input="focusNext($event)" />
                      <input type="text" maxlength="1" class="otp-input" min="0" max="9" pattern="[0-9]" id="digit3" @input="focusNext($event)" />
                      <input type="text" maxlength="1" class="otp-input" min="0" max="9" pattern="[0-9]" id="digit4" @input="focusNext($event)" />
                      <input type="text" maxlength="1" class="otp-input" min="0" max="9" pattern="[0-9]" id="digit5" @input="focusNext($event)" />
                      <input type="text" maxlength="1" class="otp-input" min="0" max="9" pattern="[0-9]" id="digit6" @input="focusNext($event)" />
                    </div>
                  </v-flex>
                </v-form>
                <v-flex class="flex-row mx-3 mt-3" v-if="error">
                  <v-icon size="17" class="red--text mr-2">warning</v-icon>
                  <span class="red--text font-weight-bold">{{ error }}</span>
                </v-flex>
                <!-- <v-flex style="display: inline-grid">
                  <span v-if="error" class="pf-text-red">{{ error }}</span>
                  <span v-else-if="success" class="text-green">{{ success }}</span>
                </v-flex> -->

              </v-card-text>
              <v-card-actions class="mt-3">
                <v-spacer></v-spacer>
                <v-btn v-if="otpVerified" class="pf-btn pf-bg-green login-btn border-radius-10" :disabled="!password || !repeatPassword || password.trim() !== repeatPassword.trim()" @click="submitPassword" ref="sigInBtn" :loading="loading">Continue</v-btn>
                <v-btn v-else-if="otpSent" class="pf-btn pf-bg-green login-btn border-radius-10" :disabled="!otp || otp.length < 6" @click="submitOTP" ref="sigInBtn" :loading="loading">Continue</v-btn>
                <v-btn v-else class="pf-btn pf-bg-green login-btn border-radius-10" :disabled="!username" @click="submitUsername" ref="sigInBtn" :loading="loading">Continue</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
              <v-flex class="flex-center my-4" v-if="otpSent && !otpVerified">
                <span>Didn't receive? <a class="pf-auth-link" @click="submitUsername($event, true)">Resend code</a></span>
              </v-flex>
              <v-flex class="flex-space-between mt-4 mx-3">
                <span class="pf-text-dark font-weight-bold cursor-pointer" @click="backToLogin">Back to Login</span>
                <a class="pf-text-dark font-weight-bold" @click="forgotUsername">Forgot Username</a>
                <a class="pf-text-dark font-weight-bold" target="_blank" :href="config.helpForm">Need Help?</a>
              </v-flex>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
/* global session, $t store config */
import { request } from '../../helpers/helpers';
import swal from 'sweetalert2';
export default {

  beforeRouteEnter (to, from, next) {
    if (session.isOnline()) {
      let role = session.getSession().user.role;
      let homePage = (role === 'admin' ? '/admin/dashboard' : (['agency', 'caseworker'].indexOf(role) > -1 ? '/agency/dashboard' : (role === 'parent' ? '/dashboard' : '/dashboard')));
      next({ path: homePage });
    } else {
      next();
    }
  },

  data: () => ({
    config,
    loading: false,
    username: '',
    otp: '',
    password: '',
    repeatPassword: '',
    error: '',
    longError: '',
    success: '',
    otpSent: false,
    otpVerified: false,
    showPassword: false,
    showPassword2: false
  }),
  computed: {
    passwordRules () {
      return [
        /* v => !!v || 'Password is required.',
        v => !!v && v.length >= 8 || 'Password cannot be less than 8 characters',
        v => /(?=.*?[A-Z])/.test(v) || 'Password must have upper case letter',
        v => /(?=.*?[0-9])/.test(v) || 'Password must have one number' */
        v => !!v || '',
        v => !!v && v.length >= 8 || '',
        v => /(?=.*?[A-Z])/.test(v) || '',
        v => /(?=.*?[0-9])/.test(v) || ''
      ];
    },
    confirmPasswordRules () {
      return [
        v => !!v || 'Please re-enter the password',
        v => v === this.password || 'Password should be match with new password',
      ];
    }
  },
  methods: {
    async submitUsername ($e, resend = false) {
      this.error = '';
      this.longError = '';
      this.loading = true;
      try {
        if (this.username) {
          let { error, data, status } = await request('Account/ResetPassword/OTP', 'POST', {
            username: this.username
          });
          this.loading = false;
          if (error) {
            this.longError = typeof error === 'string' ? error : 'Oops, failed to process the request';
          } else {
            this.error = '';
            this.longError = '';
            this.otpSent = true;
          }
          if (resend) {
            this.resetInputFields();
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    setOTP () {
      let otp = '';
      // Get the values from all input fields
      for (let i = 1; i <= 6; i++) {
        const digitInput = document.getElementById('digit' + i);
        otp += digitInput.value;
      }
      this.otp = otp;
    },
    resetInputFields () {
      for (let i = 1; i <= 6; i++) {
        const digitInput = document.getElementById('digit' + i);
        digitInput.value = '';
      }
      // Focus on the first input field after resetting
      document.getElementById('digit1').focus();
    },
    async submitOTP () {
      this.error = '';
      this.longError = '';
      this.loading = true;
      if (!this.otp || this.otp.length < 6) {
        this.error = 'Please enter a valid code';
      } else {
        let { error, data, status } = await request('Account/ResetPassword/VerifyOTP', 'POST', {
          username: this.username,
          otp: this.otp
        });
        this.loading = false;
        if (error) {
          this.error = 'Failed to verify the code';
          this.longError = 'Looks like the verification code you entered wasn\'t correct. Please type in the valid code or click on Resend code to get a new one.';
          // Reset the input fields
          this.resetInputFields();
        } else {
          this.error = '';
          this.longError = '';
          this.otpVerified = true;
        }
      }
    },
    async submitPassword () {
      this.loading = true;
      this.error = '';
      this.longError = '';
      if (this.$refs.forgotPasswordForm.validate()) {
        let { error, data, status } = await request('Account/ResetPassword/Submit', 'POST', {
          username: this.username,
          password: this.password
        });
        this.loading = false;
        if (error) {
          this.error = error;
        } else {
          this.error = '';
          this.otpVerified = true;
          swal.fire({
            type: 'success',
            title: 'The password was updated successfully',
            confirmButtonText: 'Back to Login',
            showConfirmButton: true,
          }).then(() => {
            this.backToLogin();
          });
        }
      } else {
        this.longError = 'Please review your password to ensure it meets the specified requirements listed below. Additionally, double-check and accurately re-enter your password.';
      }
    },
    focusNext (currentInput) {
      // Get the length of the value in the current input
      const inputValueLength = currentInput.target.value.length;

      // If a digit is entered, focus on the next input field
      if (inputValueLength === 1) {
        const nextInput = currentInput.target.nextElementSibling;
        
        if (nextInput) {
          nextInput.focus();
        }
      } else if (inputValueLength === 0) {
        const previousInput = currentInput.target.previousElementSibling;
        
        if (previousInput) {
          previousInput.focus();
        }
      }
      /* Set otp if last one entered */
      if (currentInput.target.id === 'digit6') {
        this.setOTP();
      }
    },
    backToLogin () {
      this.clearData();
      this.$router.push('/login');
    },
    clearData () {
      this.username = '';
      this.otp = '';
      this.password = '';
      this.repeatPassword = '';
      this.error = '';
      this.longError = '';
      this.success = '';
      this.otpSent = false;
      this.otpVerified = false;
    },
    forgotUsername () {
      this.clearData();
      this.$router.push('/forgotUsername');
    }
  }
};
</script>
<style scoped lang="css">
  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ResetPassword/ForgotPassword.vue